import type { ReactNode } from 'react';

export enum SmartCreateFeedbackVariant {
	ROVO = 'rovo',
	CREATE_WITH_ROVO = 'create-with-rovo', // Confluence
	CREATE_WITH_ROVO_FROM_JIRA = 'create-with-rovo-from-jira', // Jira
	REMIX = 'remix',
	SLIDES = 'slides',
}

export interface SmartCreateFeedbackProps {
	/**
	 * The variant of the SmartCreateFeedback component (either "Rovo" or "Create with Rovo").
	 */
	variant?: SmartCreateFeedbackVariant;

	/**
	 * Callback function to close the SmartCreateFeedback component.
	 */
	onClose: () => void;

	/**
	 * Callback function to submit the feedback.
	 */
	onSubmit: () => void;

	/**
	 * The tenant ID (cloud ID) for the feedback context.
	 */
	tenantId?: string;

	/**
	 * Additional fields to log in the feedback context.  This will be saved, so do not share UGC here.
	 */
	additionalFields?: object;

	/**
	 * Optional extra content to render below the category pills in the feedback modal.
	 * Useful for adding custom fields (e.g. a feedback textarea, a "include conversation history" checkbox).
	 */
	customContent?: ReactNode;

	/**
	 * Whether to show the default summary and description text fields. Defaults to true.
	 * Set to false when providing custom text input via customContent.
	 */
	showDefaultTextFields?: boolean;

	/**
	 * Optional default value for the summary field.
	 */
	summaryDefaultValue?: string;

	/**
	 * Optional default value for the description field.
	 */
	descriptionDefaultValue?: string;
}
